'use strict';
import Component from 'gia/Component';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe'

export default class SingleView extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    //! Fns
    this.zoom()
  }

  zoom()
  {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.DOM.view,
      children: '.js-zoom',
      pswpModule: PhotoSwipe,
      arrowPrevSVG: LIGTHBOX_CONFIG.arrowSvg,
      arrowNextSVG: LIGTHBOX_CONFIG.arrowSvg,
      zoom: false,
      counter: false,
      closeSVG:LIGTHBOX_CONFIG.closeSvg,
      showHideAnimationType: 'zoom',
      showAnimationDuration: 800,
      hideAnimationDuration: 400,
      easing:LIGTHBOX_CONFIG.easing,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 1,
      maxZoomLevel: 2,
      bgOpacity:.95
    });

    this.lightbox.init();

  }
}
